import { jsx as n } from "react/jsx-runtime";
import { Text as x, TextWrap as T } from "./styles.js";
const u = ({
  children: t,
  variant: e = "p",
  align: i,
  color: o = "--ll-color-on-background",
  lineClamp: r,
  noMargin: l,
  lineHeight: a,
  weight: p = "--ll-font-weight-medium",
  family: $ = "sans-serif",
  className: c,
  fontVariant: m = "initial",
  textTransform: s = "none",
  letterSpacing: f
}) => {
  const g = ["caption1", "caption2", "p"].includes(e) ? "p" : e;
  return /* @__PURE__ */ n(
    x,
    {
      $variant: e,
      $align: i,
      $color: o,
      $lineClamp: r,
      $weight: p,
      $family: $,
      $fontVariant: m,
      $letterSpacing: f,
      $textTransform: s,
      children: /* @__PURE__ */ n(
        T,
        {
          as: g,
          className: c,
          $noMargin: l,
          $lineHeight: a,
          children: t
        }
      )
    }
  );
};
export {
  u as Text
};
